import { cn } from '@journ/ui/cn'
import {
	DropdownMenu,
	DropdownMenuCheckboxItem,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuPortal,
	DropdownMenuSub,
	DropdownMenuSubContent,
	DropdownMenuSubTrigger,
	DropdownMenuTrigger,
} from '@journ/ui/dropdown-menu'
import { Icons } from '@journ/ui/icons'
import { useState } from 'react'
import { useIntlayer } from 'react-intlayer'
import { SearchField } from '@/components/search-field'
import type { MemberStatus } from '../domain/member'
import { MembersFilterList } from './members-filter-list'
import { useMemberParams } from './use-member-params'

const STATUSES: MemberStatus[] = ['active', 'on_leave', 'departed']

const HrHeader = () => {
	const content = useIntlayer('hr-page')
	const { q, status, setParams } = useMemberParams()
	const [isOpen, setIsOpen] = useState(false)

	const hasFilters = Boolean(status)

	return (
		<div className='flex items-center justify-between gap-4'>
			<div className='flex items-center gap-2'>
				<MembersFilterList />
				<DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
					<SearchField.Root className='min-w-72 md:min-w-120'>
						<SearchField.Input
							placeholder={content.searchPlaceholder.value}
							value={q ?? ''}
							onChange={v => setParams({ q: v })}
						/>
						<SearchField.Action>
							<DropdownMenuTrigger asChild>
								<button
									type='button'
									className={cn(
										'opacity-50 transition-opacity duration-300 hover:opacity-100',
										hasFilters ? 'opacity-100' : '',
										isOpen ? 'opacity-100' : '',
									)}
								>
									<Icons.Filter size={16} />
								</button>
							</DropdownMenuTrigger>
						</SearchField.Action>
					</SearchField.Root>

					<DropdownMenuContent className='w-55' align='end' sideOffset={10}>
						<DropdownMenuGroup>
							<DropdownMenuSub>
								<DropdownMenuSubTrigger>
									<Icons.ProjectStatus className='mr-2 size-4 rotate-180' />
									<span>{content.columns.status}</span>
								</DropdownMenuSubTrigger>
								<DropdownMenuPortal>
									<DropdownMenuSubContent sideOffset={14} alignOffset={-4}>
										{STATUSES.map(s => (
											<DropdownMenuCheckboxItem
												key={s}
												checked={status === s}
												onSelect={e => e.preventDefault()}
												onCheckedChange={() => setParams({ status: status === s ? null : s })}
											>
												{content.status[s]}
											</DropdownMenuCheckboxItem>
										))}
									</DropdownMenuSubContent>
								</DropdownMenuPortal>
							</DropdownMenuSub>
						</DropdownMenuGroup>
					</DropdownMenuContent>
				</DropdownMenu>
			</div>
		</div>
	)
}

export { HrHeader }
